<template>
  <div class="left_footer">
    <span class="title">月度销量统计</span>
    <div id="myChart" :style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
export default {
  name: "LeftFooter",
  data() {
    return {
      id: 87,
      months: [],
      values: [],
    };
  },
  created() {
    let date = new Date();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    for (let i = 0; i < 5; i++) {
      if (month === 1) {
        month = 13;
        year--;
      }
      month--;
    }
    month = month < 10 ? "0" + month : month;
    let monthString = year + "-" + month;
    this.$axios
      .get(
        `http://www.lcyjfz.com/api/business/orderReport?month=${monthString}&shopid=${this.id}`
      )
      .then((res) => {
        for (let key in res.data.data.money) {
          this.months.push(res.data.data.money[key]);
        }
        this.months.sort((a, b) => new Date(b.affirm_time) - new Date(a.affirm_time));
        let myChart = this.$echart.init(document.getElementById("myChart"));
        let monthData = this.months.map((item) => {
          return item.affirm_time.split("-")[1] + "月销量";
        });
        let valueData = this.months.map((item) => item.sale_money);
        
        let option = {
          xAxis: {
            type: "value",
            axisLabel: {
              textStyle: {
                color: "blue",
              },
            },
          },
          yAxis: {
            type: "category",
            data: monthData,
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
          },
          grid: {
            left: "15%",
            right: "4%",
            bottom: "10%",
            top: "0%",
          },
          series: [
            {
              data: valueData,
              type: "bar",
              barWidth: "60%",
              itemStyle: {
                emphasis: {
                  barBorderRadius: 30,
                },
                normal: {
                  barBorderRadius: [10, 10, 10, 10],
                  color: "blue",
                },
              },
            },
          ],
        };
        myChart.setOption(option);
      });
  },
};
</script>

<style lang="less" scoped>
.left_footer {
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  box-sizing: border-box;
  position: relative;
  .title {
    width: 80%;
    margin: 0 auto;
    position: absolute;
    top: -0.25rem;
    padding: 0 1.25rem;
    font-size: 1rem;
    text-align: center;
    left: 0;
    right: 0;
    color: white;
  }
}
</style>